export function getAriaDescribedBy(ids) {
    var filtered = ids.filter(function (id) { return !!id; });
    return filtered.length > 0 ? filtered.join(' ') : undefined;
}
//# sourceMappingURL=a11y.js.map